<div
  class="bwc-view-actions-bar-shell d-flex flex-column shadow-sm rounded-2 border cursor-pointer"
>
  <app-map-navigation-item>
    <span
      class="rb-ic rb-ic-alert-info fs-2xl hover-effect p-2"
      [class.sel-menu-item]="isLegendVisible"
      [class.rounded-top-2]="isLegendVisible"
      (click)="toggleLegend.emit()"
      placement="start"
      ngbTooltip="Show legend"
      tooltipClass="custom-tooltip"
      [openDelay]="1000"
    >
    </span>
  </app-map-navigation-item>
  <span class="map-navigation-item-divider"></span>
  <app-map-navigation-item>
    <span
      class="rb-ic rb-ic-camera fs-2xl hover-effect p-2"
      [class.sel-menu-item]="isWebcamLayerVisible"
      [class.rounded-bottom-2]="isWebcamLayerVisible"
      (click)="toggleWebcamLayer.emit()"
      placement="start"
      ngbTooltip="Show webcams"
      tooltipClass="custom-tooltip"
      [openDelay]="1000"
    >
    </span>
  </app-map-navigation-item>
</div>
